// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"1528f9a4","291":"d7bd5750","331":"9678b690","434":"3584665a","612":"1a66368b","785":"22177a32"}[chunkId] + ".chunk.js";
};